import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';

export const LoginButton = ({ label }) => {
  return (
    <RaisedButton type="submit" label={label} primary={true} fullWidth={true}/>
  );
};

export const LoginButtonDisabled = ({ label }) => {
  return (
    <RaisedButton type="button" disabled className="loader_btn" label={label} primary={true} fullWidth={true}>
      <i className="fa fa-spinner fa-spin fa-fw"></i>
    </RaisedButton>
  );
};

export const SubmitButton = ({ label }) => {
  return (
    <RaisedButton type="submit" primary={true} label={label ? label : 'Submit'} />
  );
};

export const SubmitButtonDisabled = ({ label }) => {
  return (
    <RaisedButton type="submit" className="loader_btn" primary={true} label={label ? label : 'Submit'} disabled>
      <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </RaisedButton>
  );
};

// submit button for modals ...
export const SubmitButtonModal = ({ label, onSubmit, className }) => {
  return (
    <RaisedButton type="submit" className= {className} primary={true} label={label ? label : 'Submit'} onClick={onSubmit ? onSubmit : null } />
  );
};

export const SubmitButtonModalDisabled = ({ label }) => {
  return (
    <RaisedButton type="submit" className="loader_btn" primary={true} label={label ? label : 'Submit'} disabled>
      {/* <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>*/}
    </RaisedButton>
  );
};

// Save Button
export const SaveButton = ({ label, onClick, className }) => {
  return (
    <RaisedButton primary={true} className= {className} onClick={onClick ? onClick : null } label={label ? label : 'Save'} />
  );
};

export const SaveButtonDisabled = ({ label }) => {
  return (
    <RaisedButton className="loader_btn" primary={true} label = {label ? label : 'Save'} disabled>
      <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </RaisedButton>
  );
};

// Next Button.
export const NextButton = () => {
  return (
    <RaisedButton primary={true} label="Next" />
  );
};

// Save & Continue Button.
export const SaveContinueButton = () => {
  return (
    <RaisedButton type="submit" name="save" primary={true} label="Save & Continue" />
  );
};

export const SaveContinueButtonDisabled = () => {
  return (
    <RaisedButton type="submit" className="loader_btn" primary={true} label="Save & Continue">
      <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </RaisedButton>
  );
};

export const CancelButton = ({ onTouchTap, className, btnlabel }) => {
  return (
    <RaisedButton className= {className ? `${className} grey_btn` : 'grey_btn'} label={btnlabel ? btnlabel : 'Cancel'} onTouchTap={onTouchTap}></RaisedButton>
  );
};
/* Generic button component
created by: Lovepreet Singh
note: please everyone use this button in further new pages.
*/
export const CommonButton = ({ name, label, onTouchTap, disabled, type, primary, fullWidth, className, ...props }) => {
  return (
    <RaisedButton
      name = {name}
      primary= {primary}
      fullWidth = {fullWidth}
      type = {type}
      className= {className}
      label={label}
      onTouchTap={onTouchTap}
      disabled= {disabled}
      {...props}>
    </RaisedButton>
  );
};



// WEBPACK FOOTER //
// ./src/components/buttons.js